// GLOBAL CONST
const header = document.querySelector('header');
const burger = document.querySelector('#burger');
const burgerLines = burger.querySelectorAll('path')
const mobilePane = document.querySelector('#mobile-pane');
const timelineBurger = gsap.timeline({ paused: true });
const menuTriggerArray = header.querySelectorAll('li[data-id]');
const closeDrawerArray = document.querySelectorAll('.close-wrapper')
const closeMobile = document.querySelector('.close-mobile')
const overlay = document.querySelector('#overlay-menu');
const menuAccordion = document.querySelectorAll('.menu-accordion-wrap');
const langSwitch = document.querySelector('#lang-switch');
const langList = document.querySelector('#lang-list');
const langItems = langList.querySelectorAll('li');
const searchWrapper = document.querySelector('#search-wrapper');
const searchTrigger = document.querySelectorAll('.search-trigger');
const searchLogoCopy = document.querySelector('#logo-copy');
const headerColor = document.querySelectorAll('.header-color');

// GLOBAL LET
let isOpen = false;
let isMobileWidth = null;
let activeDrawerId = null;
let scrollY = 0;
//Set up timeline burger menu
timelineBurger
  .to(burgerLines[0], {attr: {d: "M8,2 L2,8"}, x: 1, duration: 0.35})
  .to(burgerLines[1], { opacity: 0, duration: 0.35}, 0)
  .to(burgerLines[2], { attr: { d: "M8,8 L2,2" }, x: 1, duration: 0.35 }, 0);
  
// BURGER CLICK
burger.addEventListener('click', () => {
  toggleOpen()
})

// CLOSE MOBILE MENU FROM SECOND LEVEL MENU
closeMobile.addEventListener('click', () => {
  toggleOpen();
  handleSecondLevelPos(false);
  header.querySelector(`li[data-id='${activeDrawerId}']`).classList.remove('selected');
  activeDrawerId = null;
})

// TOGGLE FUNCTION
function toggleOpen() {
  isOpen = !isOpen;
  toggleWhiteBgHeader(isOpen)
  gsap.set('body', { overflow: isOpen ? 'hidden' : 'auto' });
  gsap.set(searchTrigger, { opacity: isOpen ? 0 : 1, pointerEvents: isOpen ? 'none' : 'all' });
  if (window.innerWidth > 1023) {
    checkActiveSiblingsMenu(true);
  } else if (window.innerWidth <= 1023) {
    
    burgerAnimation();
    gsap.to(mobilePane, { opacity: isOpen ? 1 : 0, pointerEvents: isOpen ? 'all' : 'none' });
  }
}

//BURGER ANIMATION
function burgerAnimation () {
  if(isOpen) timelineBurger.play()
  else if(!isOpen) timelineBurger.reverse()
}

// RESIZE RESET
function resizeHandler () {
  const tempWidth = window.innerWidth >= 1024;

  if(tempWidth && isMobileWidth != tempWidth){
    isOpen = false;
    gsap.set(mobilePane, {clearProps: 'all'})
    burgerAnimation()
  }else if(!tempWidth && isMobileWidth != tempWidth){
    isOpen = false;
    gsap.set('body', { overflow: 'auto' });
  }

  isMobileWidth = tempWidth
}
window.addEventListener('resize', resizeHandler)

// MENU ITEMS TRIGGER
menuTriggerArray.forEach((item, index) => {
  item.addEventListener('click', () => {
    //select new id
    const id = item.getAttribute('data-id');
    // check if it's the already selected one
    activeDrawerId = id === activeDrawerId ? null : id;
    toggleWhiteBgHeader(activeDrawerId!==null)
    // remove old selection
    if (activeDrawerId === null){
      item.classList.remove('selected');
      document.querySelector(`.drawer[data-id='${id}']`).classList.remove('selected');
      if (window.innerWidth > 1023) gsap.set('body', { overflow: 'auto' });
      gsap.to(overlay, { opacity: 0, pointerEvents: 'none', duration: 0.3 });
    } else {
      checkActiveSiblingsMenu()
      item.classList.toggle('selected');
      document.querySelector(`.drawer[data-id='${id}']`).classList.toggle('selected');
      handleSecondLevelPos(true);
      if (window.innerWidth > 1023) {
        gsap.set('body', { overflow: 'hidden' });
        gsap.to(overlay, { opacity: 0.75, pointerEvents: 'all', duration: 0.3 });
      }
    }
  })
})

// MOBILE SECOND LEVEL POSITION
function handleSecondLevelPos(opening) {  

  if(window.innerWidth <= 1023){
    gsap.set(
      document.querySelector(`.drawer[data-id='${activeDrawerId}']`),
      { position: opening ? 'relative' : 'absolute', delay: opening ? 0 : 0.5 });
    
    if (!opening) {
      document.querySelector(`.drawer[data-id='${activeDrawerId}']`).classList.remove('selected');
    } 

  }
  if (window.innerWidth <= 767) { 
    // open first accordion at first open
    const accordion = document.querySelectorAll(`.drawer[data-id='${activeDrawerId}'] .menu-accordion-wrap`)
    if (accordion.length > 0) {
      if (opening) accordion[0].classList.add('open')
      else if (!opening) {
    // close all accordion when closing second level menu
        const siblingOpen = document.querySelector(`.drawer[data-id='${activeDrawerId}'] .menu-accordion-wrap.open`)
        if(siblingOpen) siblingOpen.classList.remove('open')
      }
    }
  }
}

// DESKTOP CLOSE MENU
closeDrawerArray.forEach((close, i) => {
  close.addEventListener('click', () => { 
    const isMobileBack = close.classList.contains('mobile-nav')
    checkActiveSiblingsMenu(true,isMobileBack);
    toggleWhiteBgHeader(false)
    activeDrawerId = null;
    if(!isMobileBack)
      gsap.to(overlay, { opacity: 0, pointerEvents: 'none', duration: 0.3 });

  })
})

// RESET ALREADY SELECTED
function checkActiveSiblingsMenu(isClose,isMobileBack) {
  const activeMenuTrigger = document.querySelector('li[data-id].selected')
  const activeDrawer = document.querySelector('.drawer[data-id].selected')
  
  if (activeMenuTrigger) {
    const activeId = activeMenuTrigger.getAttribute('data-id')
    if (activeId !== activeDrawerId || isClose) {
      activeMenuTrigger.classList.remove('selected')
      activeDrawer.classList.remove('selected')
      handleSecondLevelPos(false)
      if(!isMobileBack)
        gsap.set('body', { overflow: 'auto' });
    }
  }
}

// OVERLAY CLICK

overlay.addEventListener('click', () => { 
  
  checkActiveSiblingsMenu(true);
  gsap.to(overlay, { opacity: 0, pointerEvents: 'none', duration: 0.3 });
  if (searchWrapper.classList.contains('open')) {
    searchWrapper.classList.remove('open')
  }
})

// sticky header
function controlSticky() {
  let prevScroll = 0;
  window.addEventListener('scroll', (e) => {
    scrollY = e.currentTarget.scrollY >= 0 ? e.currentTarget.scrollY : 0;
    const scrollDir = scrollY > prevScroll;

    // Only hide header when scrolling down AND no menu is active
    const menuActive = activeDrawerId !== null || document.querySelector('.drawer.selected') !== null || searchWrapper.classList.contains('open');
    if (!menuActive) {
      gsap.to(header, { yPercent: scrollDir ? -100 : 0, duration: 0.5 });
    } else {
      // Always show header when menu is active
      gsap.to(header, { yPercent: 0, duration: 0.5 });
    }
    
    prevScroll = scrollY
    const stickyTopElements = document.querySelectorAll('.sticky-top');

    stickyTopElements.forEach((element) => {
      
      if (scrollDir) {
        gsap.to(element, {y: 0, duration: 0.5})
      } else {   
        if (window.innerWidth > 767 || (window.innerWidth <= 767 && element.classList.contains('sticky-top-responsive'))) {
          if (element.parentNode.getBoundingClientRect().y > gsap.getProperty(':root', "--header-height")) { 
            gsap.to(element, {y: 0, duration: 0.5})
          } else {
            gsap.to(element,
            {
              y: () => gsap.getProperty(':root', "--header-height"),
              duration: 0.5
            })
          }
        }
      }
    })
    
    // Restore this code for background color toggling
    if (scrollY > 0) {
      toggleWhiteBgHeader(true)
    } else {
      toggleWhiteBgHeader(false)
    }
    
    if(langList.classList.contains('open')){
      langList.classList.remove('open')
      gsap.to(langList, { opacity: 0, pointerEvents: 'none', duration: 0.3 });
    }
  })
}
controlSticky()

// MOBILE ACCORDION

menuAccordion.forEach((item, index) => {
  item.querySelector('.menu-accordion').addEventListener('click', () => {
    
    if(item.classList.contains('open'))
      item.classList.remove('open');
    else {
      checkAccordionSiblings()
      item.classList.add('open');
      
    }
  })
})


function checkAccordionSiblings(){
  menuAccordion.forEach((item, index) => {
    if (item.classList.contains('open')) {
      item.classList.remove('open')
    } 
  })
}

// LANGUAGE SWITCH

langSwitch.addEventListener('click', () => {
  langList.classList.toggle('open');
  if(langList.classList.contains('open')){
    gsap.to(langList, { opacity: 1, pointerEvents: 'all', duration: 0.3 });
  } else {
    gsap.to(langList, { opacity: 0, pointerEvents: 'none', duration: 0.3 });
  }
})

// SEARCH TRIGGER

searchTrigger.forEach((item, index) => {
  item.addEventListener('click', () => {
    searchWrapper.classList.toggle('open')
    if (searchWrapper.classList.contains('open')) {
      if(document.querySelector('.drawer.selected')) {
        checkActiveSiblingsMenu(true);
        activeDrawerId = null;
      } 
      gsap.set('body', { overflow: 'hidden' });
      gsap.to(overlay, { opacity: 0.75, pointerEvents: 'all', duration: 0.3 });
      
    } else {
      gsap.set('body', { overflow: 'auto' });
      gsap.to(overlay, { opacity:0, pointerEvents: 'none', duration: 0.3 });
    }
  })
})


const toggleWhiteBgHeader = (apply) => {
  
  headerColor.forEach((element) => {
      if (apply) {
        if (!element.classList.contains('bg-neutrals-white')) element.classList.add('bg-neutrals-white')
        if (element.classList.contains('bg-transparent')) element.classList.remove('bg-transparent')
      } else {        
        if (scrollY < gsap.getProperty(':root', "--header-height")) {
          if (element.classList.contains('bg-neutrals-white')) element.classList.remove('bg-neutrals-white')
          if (!element.classList.contains('bg-transparent')) element.classList.add('bg-transparent')
        }
      }
    })
  
}